// extracted by mini-css-extract-plugin
module.exports = {"item":"galleryGrid_item__-facg","image":"galleryGrid_image__35NE4","deleteBtn":"galleryGrid_deleteBtn__3RXLu"};